export enum DirectoryTypes {
  SearchAndDiscovery = 1,
  VoiceSearch = 2,
  SocialAndReputation = 3,
  NavigationServices = 4,
  BusinessDirectories = 5,
  Unknown = 6
}